import { imageUrl } from 'utils/filestack';

type Props = {
  handle: string;
  width?: number;
  height?: number;
  round?: boolean;
  fit?: string;
  format?: string;
  mimetype: string;
  quality?: number;
};

export function getImageSrc({
  handle,
  width,
  height,
  round,
  fit,
  format,
  mimetype,
  quality,
}: Props) {
  const resize = [
    width && `w:${Math.round(width)}`,
    height && `h:${Math.round(height)}`,
  ]
    .filter(Boolean)
    .join(',');

  const resizeQuery = resize && `resize=${resize}${fit ? `,fit:${fit}` : ''}`;
  const qualityQuery = `quality=value:${quality || 70}`;
  const shapeQuery = round && 'circle';
  const formatQuery = format && `output=format:${format}`;

  const transform = [resizeQuery, qualityQuery, shapeQuery, formatQuery]
    .filter(Boolean)
    .join('/');

  return imageUrl({ handle, mimetype, transform });
}
